import PageSalon from "../pages/PageSalon";

import ImgLogo from "../assets/images/amelie_logo.png";
import PageEquipe from "../pages/PageEquipe";
import PageGalerie from "../pages/PageGalerie";
import PageContact from "../pages/PageContact";
import PagePrestations from "../pages/PagePrestations";
import PageEngagements from "../pages/PageEngagements";

export const settings = {
  websiteName: "https://amelieparis15.fr",
  compagnieName: "Amélie...",
  rdvLink: "https://www.planity.com/amelie-coiffeur-paris-15-75015",
  storageDirFromScript: "../storage/", //"../../storage",
  // scriptsDir: "http://localhost/amelie-15/scripts/",
  // scriptsDir: "https://amelie-15.digibuddy.fr/scripts/",
  scriptsDir: "/scripts/",
  adminPassword: "ISMvKXpXpadDiUoOSoAfww==",
  timestamp: 1711920000,
  navbar: {
    height: "5rem",
    backgroundColor: "#000000",
    fontColor: "white",
    logoImg: <img src={ImgLogo} alt="logo" />,
    logoPosition: "center",
  },
  pages: {
    pageMaxWidth: "800px",
    salon: {
      title: "Le Salon",
      path: "/",
      position: "left",
      component: <PageSalon pageKey={"salon"} />,
    },
    equipe: {
      title: "L'équipe",
      position: "left",
      component: <PageEquipe pageKey={"equipe"} />,
    },
    prestations: {
      title: "Prestations",
      position: "left",
      component: <PagePrestations pageKey={"prestations"} />,
    },
    engagements: {
      title: "Engagements",
      position: "left",
      component: <PageEngagements pageKey={"engagements"} />,
    },
    galerie: {
      title: "Galerie",
      position: "right",
      component: <PageGalerie pageKey={"galerie"} />,
    },
    contact: {
      title: "Contact",
      position: "right",
      component: <PageContact pageKey={"contact"} />,
    },
  },
  footer: {
    logo: "/logo-white.png",
    description:
      "Salon de coiffure basé sur Paris<br/>dans le 15e arrondissement",
    address: "57 boulevard de Vaugirard<br/>75015 Paris",
    phone: "<a href='tel:0143208431'>01 43 20 84 31</>",
    hours: {
      lundi: "Fermé",
      Mardi: "10h-19h",
      Mercredi: "10h-19h",
      Jeudi: "10h-20h",
      Vendredi: "10h-19h",
      Samedi: "09h30-18h",
      Dimanche: "Fermé",
    },
    facebook: "https://www.facebook.com/salonamelieparis15",
    instagram: "https://www.instagram.com/amelieparis15/",
    spotify: "playlist/64KdIF1Rg7XJ25pfnT6c4P?utm_source=generator&theme=0",
    google: "https://g.co/kgs/ESHtttz",
  },
};
